import * as _ from 'lodash';
import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {SelectedFilterValuesModel} from '../../dialogs/grid-filter/selected-filter-values.model';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef, MatDialogTitle, MatDialogClose, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import {LookupModel} from '../../api/models/lookup-model';
import {PhoneNumbersUtils} from '../../core/utilities/phone-numbers-helpers';
import { FlexModule } from '@angular/flex-layout';
import { MatIconButton, MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { FormsModule } from '@angular/forms';
import { CardOptionsComponent } from '../../core/visual/card/options-card.component';
import { CardComponent } from '../../core/visual/card/card.component';
import { MatPhoneNumberInputComponent } from '../../editors/mat-phone-number-input/mat-phone-number-input.component';

export interface FaxListCurrentFilterData {
  filter: Array<SelectedFilterValuesModel>;
  faxNumbers: LookupModel[];
}

@Component({
    selector: 'app-fax-list-filter-dialog',
    templateUrl: './fax-list-filter-dialog.component.html',
    styleUrls: ['./fax-list-filter-dialog.component.scss'],
    standalone: true,
    imports: [
        FlexModule,
        MatDialogTitle,
        MatIconButton,
        MatDialogClose,
        MatIcon,
        CdkScrollable,
        MatDialogContent,
        FormsModule,
        CardOptionsComponent,
        CardComponent,
        MatPhoneNumberInputComponent,
        MatDialogActions,
        MatButton,
    ],
})
export class FaxListFilterDialogComponent implements OnInit, OnDestroy {

  filterByStatusOptions = [
    {value: 'Failed', text: 'Failed', id: _.uniqueId('id_')},
    {value: 'Processing', text: 'Processing', id: _.uniqueId('id_')},
    {value: 'Success', text: 'Success', id: _.uniqueId('id_')},
  ];

  filterByTypeOptions = [
    {value: 'incoming', text: 'Incoming', id: _.uniqueId('id_')},
    {value: 'outgoing', text: 'Outgoing', id: _.uniqueId('id_')},
  ];

  faxNumbers: LookupModel[] = [];

  checkedFaxNumbers: any[] = [];
  checkedStatusOptions: any[] = [];
  checkedTypeOptions: any[] = [];
  filterToNumber: string;
  filterFromNumber: string;


  constructor(public dialogRef: MatDialogRef<FaxListFilterDialogComponent>,
              public dialog: MatDialog,
              @Inject(MAT_DIALOG_DATA) public data: FaxListCurrentFilterData) {
  }

  ngOnInit() {
    this.faxNumbers = this.data.faxNumbers || [];

    if (this.data.filter) {
      for (const filterOption of this.data.filter) {
        if (filterOption.filterKey === 'numberTo') {
          this.filterToNumber = filterOption.values[0];
        } else if (filterOption.filterKey === 'numberFrom') {
          this.filterFromNumber = filterOption.values[0];
        } else if (filterOption.filterKey === 'faxNumbers') {
          this.checkedFaxNumbers = filterOption.values;
        } else if (filterOption.filterKey === 'statuses') {
          this.checkedStatusOptions = filterOption.values;
        } else if (filterOption.filterKey === 'types') {
          this.checkedTypeOptions = filterOption.values;
        }
      }
    }
  }

  ngOnDestroy() {
  }

  closeSendConfirmPopup(action: string) {
    if (action === 'close') {
      this.dialogRef.close();
    } else {
      const filter: SelectedFilterValuesModel[] = [];

      if (this.filterToNumber) {
        filter.push({
          filterKey: 'numberTo',
          multiValue: false,
          title: 'To Number',
          values: [this.filterToNumber],
          displayValues: [PhoneNumbersUtils.format(this.filterToNumber)]
        });
      }

      if (this.filterFromNumber) {
        filter.push({
          filterKey: 'numberFrom',
          multiValue: false,
          title: 'From Number',
          values: [this.filterFromNumber],
          displayValues: [PhoneNumbersUtils.format(this.filterFromNumber)]
        });
      }

      if (this.checkedFaxNumbers && this.checkedFaxNumbers.length > 0) {
          filter.push({
            filterKey: 'faxNumbers',
            title: 'Fax Number',
            multiValue: true,
            values: this.checkedFaxNumbers,
            displayValues: this.checkedFaxNumbers.map(x => PhoneNumbersUtils.format(x))
          });
      }

      if (this.checkedStatusOptions && this.checkedStatusOptions.length > 0) {
        filter.push({
          filterKey: 'statuses',
          title: 'Status',
          multiValue: true,
          values: this.checkedStatusOptions,
          displayValues: this.checkedStatusOptions
        });
      }

      if (this.checkedTypeOptions && this.checkedTypeOptions.length > 0) {
        filter.push({
          filterKey: 'types',
          title: 'Type',
          multiValue: true,
          values: this.checkedTypeOptions,
          displayValues: this.checkedTypeOptions
        });
      }

      this.dialogRef.close(filter);
    }
  }
}
